import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator, AppServerAPI, Identity } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { LogContainer } from '@sdbn/tmc-common';
import { TerminalContextConstants } from '@sdbn/tmc-common';
import { AdditionalVisitor, InviteVisitor } from '../widgets/terminal/additional-visitors/additional-visitor.model';

export class VisitorAdditionalVisitorController extends AbstractStepController {

    private appServerAPI: AppServerAPI;
    private nextControl = new StepControl();

    onContextChange(contextChange: ContextChange) {
        if (contextChange.key === 'inviteVisitor') {
            this.appServerAPI.execute<InviteVisitor>('/terminal/registration/visitor/invite-visitor', contextChange.value).subscribe(result => {
                this.loadAdditionalVisitors();
            });
        }
    }

    onRegisterToDashboardContext() {
        this.appServerAPI = WizardServiceLocator.injector.get(AppServerAPI);
        this.loadAdditionalVisitors();
    }

    public handleFlow(): FlowStepHandleResult {
        this.wizardComponent.startInactivityMonitoring();
        const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        logContainer.addLog('maintain additional visitor started');

        const result = new FlowStepHandleResult();
        result.type = HandleResultType.DASHBOARD;
        return result;
    }

    private cancel() {

        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.restartWizard();

    }

    getControls(): StepControl[] {
        const controls = new Array<StepControl>();

        let spacer = new StepControl();
        spacer.type = StepControlType.SPACER_GROW;
        controls.push(spacer);

        const cancelControl = new StepControl();
        cancelControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.close';
        cancelControl.type = StepControlType.BUTTON_STROKED;
        cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
        cancelControl.controlAction = this.cancel.bind(this);
        controls.push(cancelControl);

        return controls;
    }

    private loadAdditionalVisitors() {
        const identity = new Identity();
        identity.id = this.dashboardContext.getContextValue(TerminalContextConstants.registrationId)
        // Load existing additional visitors
        this.appServerAPI.execute<Array<AdditionalVisitor>>('/terminal/registration/visitor/get-additional-visitors', identity).subscribe(result => {
            if (result == null) {
                this.dashboardContext.setContextValue('additionalVisitors', new Array<AdditionalVisitor>());
            } else {
                this.dashboardContext.setContextValue('additionalVisitors', new Array<AdditionalVisitor>(...result.map(r => new AdditionalVisitor(r))));
            }
        });
    }
}
